import { render } from "./SupplierMasterdata.vue?vue&type=template&id=2ed85f7f"
import script from "./SupplierMasterdata.vue?vue&type=script&lang=js"
export * from "./SupplierMasterdata.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__